export function getChatroomScrollIsNearBottom({ element, threshold }) {
  return (
    element.scrollHeight - element.scrollTop - element.clientHeight < threshold
  )
}

export function getChatroomIsOwnLastMessage({ currentUserId, messages }) {
  if (!currentUserId || messages.length === 0) {
    return false
  }

  return messages[messages.length - 1]?.owner === currentUserId
}

export function scrollChatroomToBottom(element) {
  element.scrollTop = element.scrollHeight
}

export function scrollChatroomToElement(element, target) {
  const targetRect = target.getBoundingClientRect()
  const containerRect = element.getBoundingClientRect()

  element.scrollTop += targetRect.top - containerRect.top
}
